import tagInput from "../tag_input";
import "./tabular_instructors";

document.addEventListener("DOMContentLoaded", function () {
  const instructorTags = document.querySelector("#instructor_tags");

  if (instructorTags) {
    tagInput(instructorTags);
  }
});
